
(function () {

	const $device = document.querySelector('.js-device');
	function setBodyClass() {
		var ua = navigator.userAgent;

		if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
			// スマートフォン
			$device.classList.remove('is-pc', 'is-tab', 'is-sp');
			$device.classList.add('is-sp');
		} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
			// タブレット
			$device.classList.remove('is-pc', 'is-tab', 'is-sp');
			$device.classList.add('is-tab');

		} else if (navigator.platform == "MacIntel" && navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {

			// Mac iPad の比較
			if (navigator.standalone !== undefined) {
				// iPad OS
				$device.classList.remove('is-pc', 'is-tab', 'is-sp');
				$device.classList.add('is-tab');
			} else {
				// mac OS
				$device.classList.remove('is-pc', 'is-tab', 'is-sp');
				$device.classList.add('is-pc');
			}

		} else {
			// その他PC
			$device.classList.remove('is-pc', 'is-tab', 'is-sp');
			$device.classList.add('is-pc');

		}
	}
	window.addEventListener('load', setBodyClass);
	window.addEventListener('resize', setBodyClass);
}());